'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

(function(AmlStatus2) {
  AmlStatus2["PROCESSING"] = "Processing";
  AmlStatus2["PENDING"] = "Pending";
  AmlStatus2["NOT_SET"] = "NotSet";
  AmlStatus2["REQUESTED"] = "Requested";
  AmlStatus2["REJECTED"] = "Rejected";
  AmlStatus2["USER_REQUESTED"] = "UserRequested";
  AmlStatus2["APPROVED"] = "Approved";
  AmlStatus2["PENDING_REQUEST"] = "PendingRequest";
})(exports.AmlStatus || (exports.AmlStatus = {}));
(function(DocumentType2) {
  DocumentType2["PHOTO_ID"] = "photoID";
  DocumentType2["ADDRESS"] = "address";
  DocumentType2["PAYMENT"] = "payment";
  DocumentType2["SOURCE_OF_WEALTH"] = "SOWQ";
  DocumentType2["SOURCE_OF_WEALTH_DOCUMENTS"] = "SOWD";
  DocumentType2["SOURCE_OF_FUNDS"] = "SOF";
})(exports.DocumentType || (exports.DocumentType = {}));
